<template>
  <div class="machine-edit">
    <p class="page-title">
      <!-- {{ `${$route.params.id !== "0" ? "编辑" : "新建"}设备信息` }} -->
      {{ `${$route.params.id === "0" ? `新建` : `编辑`}设备` }}
    </p>
    <!-- 返回上一页 -->
    <el-button
      class="pull-right"
      type="primary"
      plain
      size="mini"
      @click.prevent="back()"
      ><i class="el-icon-back"></i>返回</el-button
    >
    <div class="page-card">
      <el-tabs v-model="activeTab">
        <!-- 基本信息 -->
        <el-tab-pane :label="`基本信息`" name="basic">
          <div class="page-section">
            <el-form
              :model="form"
              :rules="rules"
              ref="form"
              label-width="170px"
              :inline="true"
              class="demo-form-inline"
            >
            <!-- 品牌 -->
              <el-form-item :label="`品牌`" prop="brand">
                <el-input :placeholder="`请输入`" class="input200" v-model="form.brand"></el-input>
              </el-form-item>
              <!-- 设备名 -->
              <el-form-item :label="`名称`" prop="name">
                <el-input :placeholder="`请输入`" class="input200" v-model="form.name"></el-input>
              </el-form-item>
              <!-- 设备状态 -->
              <el-form-item :label="`状态`" prop="status">
                <el-select
                  class="input200"
                  v-model="form.status"
                  :placeholder="`请选择`"
                >
                  <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 设备类型 -->
              <el-form-item :label="`类型`" prop="type">
                <el-select
                  class="input200"
                  v-model="form.type"
                  :placeholder="`请选择`"
                  @change="changeFormRequired()"
                >
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="设备区域:" prop="equipment_area">
                <el-select class="input200" v-model="form.equipment_area" placeholder="请选择">
                  <el-option
                    v-for="item in areas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- 生产厂家 -->
              <!-- <el-form-item :label="`生产厂家`" prop="create_vendor_id">
                <el-select
                  class="input200"
                  filterable
                  v-model="form.create_vendor_id"
                  :placeholder="`请选择`"
                >
                  <el-option
                    v-for="item in createVendors"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- 经销厂家 -->
              <!-- <el-form-item :label="`经销厂家`" prop="sale_vendor_id">
                <el-select
                  class="input200"
                  filterable
                  v-model="form.sale_vendor_id"
                  :placeholder="`请选择`"
                >
                  <el-option
                    v-for="item in saleVendors"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- 设备价格 -->
              <!-- <el-form-item :label="`价格`" prop="price">
                <el-input class="input200" v-model="form.price" :placeholder="`请输入`"></el-input>
              </el-form-item> -->
              <!-- 使用年限 -->
              <el-form-item :label="`使用年限`" prop="life_time">
                <el-date-picker
                  class="input200"
                  v-model="form.life_time"
                  type="date"
                  :placeholder="`请选择`"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <!-- 灭菌方式 -->
              <el-form-item
                :label="`灭菌方式`"
                prop="handle_type"
                v-show="form.type === 2"
              >
                <el-select
                  class="input200"
                  v-model="form.handle_type"
                  :placeholder="`请选择`"
                  @change="handleTypeChange"
                >
                  <el-option
                    v-for="item in cleanMethods"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 生物检测时间 -->
              <!-- <el-form-item
                :label="`生物检测时间`"
                prop="biological_time"
                v-show="form.type === 2"
              >
                <el-select class="input200" v-model="form.biological_time" :placeholder="`请选择`" clearable>
                  <el-option v-for="(p, pi) in bilogcheckTimeOptions"
                    :key="pi"
                    :value="p.value"
                    :label="p.name">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- 联系人 -->
              <el-form-item :label="`联系人`" prop="contact">
                <el-input :placeholder="`请输入`" class="input200" v-model="form.contact"></el-input>
              </el-form-item>
              <!-- 联系电话 -->
              <el-form-item :label="`联系电话`" prop="contact_phone">
                <el-input
                  class="input200"
                  :placeholder="`请输入`"
                  v-model="form.contact_phone"
                ></el-input>
              </el-form-item>
              <!-- 移动电话 -->
              <!-- <el-form-item :label="`移动电话`" prop="contact_mobile">
                <el-input
                  class="input200"
                  :placeholder="`请输入`"
                  v-model="form.contact_mobile"
                ></el-input>
              </el-form-item> -->
              <!-- 初次使用时间 -->
              <el-form-item :label="`初次使用时间`" prop="first_time">
                <el-date-picker
                  class="input200"
                  v-model="form.first_time"
                  type="date"
                  :placeholder="`请选择`"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <!-- 设备责任人 -->
              <el-form-item :label="`设备责任人`" prop="charge_person">
                <el-input
                  class="input200"
                  v-model="form.charge_person"
                  :placeholder="`请输入`"
                ></el-input>
              </el-form-item>
              <!-- 科室责任人 -->
              <!-- <el-form-item :label="`科室责任人`" prop="department_person">
                <el-input
                  class="input200"
                  v-model="form.department_person"
                  :placeholder="`请输入`"
                ></el-input>
              </el-form-item> -->
              <!-- 规格型号 -->
              <el-form-item :label="`规格型号`" prop="specification">
                <el-input
                  class="input200"
                  :placeholder="`请输入`"
                  v-model="form.specification"
                ></el-input>
              </el-form-item>
              <!-- 详情描述 -->
              <el-form-item :label="`描述`" prop="remark">
                <el-input
                  class="input200"
                  :placeholder="`请输入`"
                  v-model="form.remark"
                  :rows="2"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <!-- 质控设备类型 -->
              <!-- <el-form-item :label="`质控设备类型`" prop="qc_type">
                <el-select
                  class="input200"
                  v-model="form.qc_type"
                  :placeholder="`请选择`"
                >
                  <el-option
                    v-for="item in qcTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- 质控灭菌类型 -->
              <!-- <el-form-item :label="`质控灭菌类型`" prop="qc_sterilization_type">
                <el-select
                  class="input200"
                  v-model="form.qc_sterilization_type"
                  :placeholder="`请选择`"
                >
                  <el-option
                    v-for="item in qcSterilizationTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- 运行费用 -->
              <!-- <el-form-item
                v-show="form.type === 2"
                :label="`运行费用`"
                prop="run_fee"
              >
                <el-input-number
                  class="input150"
                  v-model="form.run_fee"
                  :min="0"
                  :precision="2"
                  :step="0.01"
                ></el-input-number>
                <span class="ml5">元 / 锅次</span>
              </el-form-item> -->
              <!-- 默认设备 -->
              <!-- <el-form-item
                class="input320"
                :label="`默认`"
                prop="is_default"
              >
                <el-radio v-model="form.is_default" :label="0">否</el-radio>
                <el-radio v-model="form.is_default" :label="1">是</el-radio>
              </el-form-item> -->
              <!-- 锅次每天清零 -->
              <!-- <el-form-item
                class="input320"
                :label="`锅次每天清零`"
                prop="reset_pot_number"
              >
                <el-radio v-model="form.reset_pot_number" :label="0"
                  >否</el-radio
                >
                <el-radio v-model="form.reset_pot_number" :label="1"
                  >是</el-radio
                >
              </el-form-item> -->
              <!-- 灭菌器禁止不同灭菌方式的包 -->
              <!-- <el-form-item
                label-width="195px"
                v-if="form.type === 2"
                class="input320"
                :label="`灭菌器禁止不同灭菌方式的包`"
                prop="is_forbid"
              >
                <el-radio v-model="form.is_forbid" :label="0">否</el-radio>
                <el-radio v-model="form.is_forbid" :label="1">是</el-radio>
              </el-form-item> -->
              <!-- 每锅需要做生物监测 -->
              <!-- <el-form-item
                v-if="form.type === 2"
                class="input320"
                :label="`每锅需要做生物监测`"
                prop="is_force_biotest"
              >
                <el-radio v-model="form.is_force_biotest" :label="0">否</el-radio>
                <el-radio v-model="form.is_force_biotest" :label="1">是</el-radio>
              </el-form-item> -->
              <!-- 运行打印 -->
              <!-- <el-form-item
                class="input320"
                :label="`运行打印`"
                prop="is_run_print"
              >
                <el-radio v-model="form.is_run_print" :label="0">否</el-radio>
                <el-radio v-model="form.is_run_print" :label="1">是</el-radio>
              </el-form-item> -->
              <!-- 结束校准 -->
              <el-form-item
                v-if="form.type === 1"
                class="input320"
                :label="`结束校准`"
                prop="is_end_pot"
              >
              <!-- 否 是 -->
                <el-radio v-model="form.is_end_pot" :label="0">否</el-radio>
                <el-radio v-model="form.is_end_pot" :label="1">是</el-radio>
              </el-form-item>
            </el-form>
          </div>
          <div class="page-section mt10">
            <span class="ml10 fontsize15">照片</span>
            <el-button
              type="primary"
              icon="el-icon-camera" 
              size="mini"
              class="input150"
              @click="uploadPicture()"
              style="margin-left: 20px"
              >上传</el-button
            >
            <div
              class="upload_img mb10"
              v-if="form.image && form.image.length > 0"
            >
              <div
                class="img"
                v-for="(image, index) in form.image"
                :key="index"
              >
                <!-- <img :src="image.url"> -->
                <el-image
                  :src="image.url"
                  :preview-src-list="form.image.map((i) => i.url)"
                />
                <i class="el-icon-error del" @click="delImg(index)"></i>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="`程序`" name="program">
          <div class="page-section d-flex">
            <el-form
              :model="programForm"
              ref="programForm"
              :rules="programRules"
              class="demo-dynamic"
            >
            <!-- 程序名 -->
              <el-form-item label-width="195px" :label="`名称`" prop="name">
                <el-input
                  class="input200"
                  :placeholder="`请输入`" 
                  v-model="programForm.name"
                ></el-input>
              </el-form-item>
              <!-- 程序码 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`编码`"
                prop="code"
              >
                <el-input
                  class="input200"
                  :placeholder="`请输入`" 
                  v-model="programForm.code"
                  disabled
                ></el-input>
              </el-form-item>
              <!-- 时长 -->
              <el-form-item label-width="195px" class="mt10" :label="`时长`">
                <el-input-number
                  class="p12 input200"
                  v-model="programForm.time"
                  :min="1"
                  label="描述文字"
                ></el-input-number>
              </el-form-item>
              <!-- BD -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`BD`"
                prop="is_bd"
              >
                <el-radio
                  v-model="programForm.is_bd"
                  :label="1"
                  :disabled="form.type !== 2 || form.handle_type !== 1"
                  @change="handleBDChange(programForm)"
                  >是</el-radio
                >
                <el-radio
                  v-model="programForm.is_bd"
                  :label="0"
                  :disabled="form.type !== 2 || form.handle_type !== 1"
                  @change="handleBDChange(programForm)"
                  >否</el-radio
                >
              </el-form-item>
              <!-- 是否测漏 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`测漏`"
                prop="is_test"
              >
                <el-radio
                  v-model="programForm.is_test"
                  :label="1"
                  :disabled="
                    form.type !== 2 ||
                    form.handle_type !== 1 ||
                    programForm.is_bd == 1
                  "
                  @change="handleTestChange(programForm)"
                  >是</el-radio
                >
                <el-radio
                  v-model="programForm.is_test"
                  :label="0"
                  :disabled="
                    form.type !== 2 ||
                    form.handle_type !== 1 ||
                    programForm.is_bd == 1
                  "
                  @change="handleTestChange(programForm)"
                  >否</el-radio
                >
              </el-form-item>
              <!-- 是否空锅运行 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`空锅运行`"
                prop="can_empty"
              >
                <el-radio 
                  v-model="programForm.can_empty" 
                  :label="1" 
                  :disabled="programForm.is_force_empty === 1"
                  >是</el-radio
                >
                <el-radio 
                  v-model="programForm.can_empty" 
                  :label="0"
                  :disabled="programForm.is_force_empty === 1"
                  >否</el-radio
                >
              </el-form-item>
              <!-- 是否是默认 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`默认`"
                prop="is_default"
              >
                <el-radio v-model="programForm.is_default" :label="1"
                  >是</el-radio
                >
                <el-radio v-model="programForm.is_default" :label="0"
                  >否</el-radio
                >
              </el-form-item>
              <!-- 侧漏程序检验时间 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`测漏程序检验时间`"
                v-if="programForm.is_test"
              >
                <el-select
                  v-model="programForm.leak_check_day"
                  :placeholder="`请选择`"
                  multiple
                >
                  <el-option
                    v-for="item in checkDayoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 是否默认生物监测 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`默认生物监测`"
                prop="is_default_biotest"
                v-if="form.type === 2"
              >
                <el-radio v-model="programForm.is_default_biotest" @change="changeBiotest()" :label="1">是</el-radio>
                <el-radio v-model="programForm.is_default_biotest" @change="changeBiotest()" :label="0">否</el-radio>
              </el-form-item>
              <!-- 生物监测频率 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`生物监测频率`"
                prop="biotest_times"
                v-if="form.type === 2 && programForm.is_default_biotest === 1"
              >
              <!-- 首次 -->
                <el-radio v-model="programForm.biotest_times" :label="1">首次</el-radio>
                <!-- 每次 -->
                <el-radio v-model="programForm.biotest_times" :label="2">每次</el-radio>
              </el-form-item>
              <!-- 强制空锅并保留原有上架数据 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`强制空锅并保留原有上架数据`"
                prop="is_force_empty"
                v-if="form.type === 2"
              >
                <el-radio v-model="programForm.is_force_empty" @change="handleForceEmptyChange(programForm)" :label="1">是</el-radio>
                <el-radio v-model="programForm.is_force_empty" @change="handleForceEmptyChange(programForm)" :label="0">否</el-radio>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item
                label-width="195px"
                class="mt10"
                :label="`备注`"
                prop="remark"
              >
                <el-input
                  class="input200"
                  :rows="4"
                  :placeholder="`请输入`" 
                  type="textarea"
                  v-model="programForm.remark"
                ></el-input>
              </el-form-item>
              <el-form-item label-width="195px">
                <!-- 新增程序 -->
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-plus"
                  @click.prevent="addProgram()"
                  >新增</el-button
                >
              </el-form-item>
            </el-form>
            <div class="d-flex flex-card">
              <template v-for="(item, index) in form.program">
                <div class="equipment_card" :key="index">
                  <el-card class="box-card" shadow="hover">
                    <div slot="header" class="clearfix">
                      <span>{{ item.name }}</span>
                      <el-button
                        style="float: right; padding: 3px 0"
                        type="text"
                        @click.prevent="deleteProgram(index)"
                        >删除</el-button
                      >
                    </div>
                    <div class="text item">
                      <!-- 编码 -->
                      <label>编码 </label>
                      <el-input
                        class="input100"
                        size="mini"
                        v-model="item.code"
                        disabled
                      ></el-input>
                      <div class="mt5"></div>
                      <!-- 时长 -->
                      <label>时长 </label>
                      <el-input
                        class="input100"
                        size="mini"
                        v-model="item.time"
                      ></el-input>
                      <br />
                      <!-- 是否BD： -->
                      <label>BD </label>
                      <br />
                      <el-radio
                        v-model="item.is_bd"
                        :label="1"
                        :disabled="form.type !== 2 || form.handle_type !== 1"
                        @change="handleBDChange(item)"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="item.is_bd"
                        :label="0"
                        :disabled="form.type !== 2 || form.handle_type !== 1"
                        @change="handleBDChange(item)"
                        >否</el-radio
                      >
                      <br />
                      <!-- 是否测漏： -->
                      <label>测漏 </label>
                      <br />
                      <el-radio
                        v-model="item.is_test"
                        :label="1"
                        :disabled="
                          form.type !== 2 ||
                          form.handle_type !== 1 ||
                          item.is_bd == 1
                        "
                        @change="handleTestChange(item)"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="item.is_test"
                        :label="0"
                        :disabled="
                          form.type !== 2 ||
                          form.handle_type !== 1 ||
                          item.is_bd == 1
                        "
                        @change="handleTestChange(item)"
                        >否</el-radio
                      >
                      <br />
                      <!-- 是否空锅运行： -->
                      <label>空锅运行 </label>
                      <br />
                      <el-radio 
                        v-model="item.can_empty" 
                        :label="1"
                        :disabled="
                          item.is_force_empty === 1
                        "
                        >是</el-radio
                      >
                      <el-radio 
                        v-model="item.can_empty" 
                        :label="0"
                        :disabled="
                          item.is_force_empty === 1
                        "
                        >否</el-radio
                      >
                      <br />
                      <!-- 是否是默认： -->
                      <label>默认 </label>
                      <br />
                      <el-radio
                        v-model="item.is_default"
                        :label="1"
                        @change="handleDefaultChange(item)"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="item.is_default"
                        :label="0"
                        @change="handleDefaultChange(item)"
                        >否</el-radio
                      >
                      <br />
                      <div v-if="form.type === 2">
                        <!-- 是否默认生物监测 -->
                        <label>默认生物监测 </label>
                        <br />
                        <el-radio v-model="item.is_default_biotest" @change="handleBiotestChange(item)" :label="1">是</el-radio>
                        <el-radio v-model="item.is_default_biotest" @change="handleBiotestChange(item)" :label="0">否</el-radio>
                        <div v-if="item.is_default_biotest === 1">
                          <!-- 生物监测频率 -->
                          <label>生物监测频率 </label>
                          <!-- 首次 -->
                          <el-radio v-model="item.biotest_times" :label="1">首次</el-radio>
                          <!-- 每次 -->
                          <el-radio v-model="item.biotest_times" :label="2">每次</el-radio>
                        </div>
                      </div>
                      <div>
                        <div v-if="item.is_test">
                          <!-- 侧漏程序检验时间： -->
                          <label>测漏程序检验时间 </label>
                          <br />
                          <el-select
                            v-model="item.leak_check_day"
                            :placeholder="`请选择`"
                            multiple
                          >
                            <el-option
                              v-for="item in checkDayoptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                          <br />
                        </div>
                        <!-- <div v-else style="height:65px">
                        </div> -->
                      </div>
                      <div v-if="form.type === 2">
                        <!-- 强制空锅并保留原有上架数据： -->
                        <label>强制空锅并保留原有上架数据 </label>
                        <br />
                        <el-radio
                          v-model="item.is_force_empty"
                          :label="1"
                          @change="handleForceEmptyChange(item)"
                          >是</el-radio
                        >
                        <el-radio
                          v-model="item.is_force_empty"
                          :label="0"
                          @change="handleForceEmptyChange(item)"
                          >否</el-radio
                        >
                      </div>
                     
                      <label>备注</label>
                      <el-input
                        type="textarea"
                        size="mini"
                        v-model="item.remark"
                      ></el-input>
                      <br />
                    </div>
                  </el-card>
                </div>
              </template>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="`附件`" name="file">
          <div class="page-section">
            <p class="section-title">
              <el-button @click="uploadFile()" size="mini" type="primary"
                ><i class="el-icon-upload2">上传</i></el-button
              >
            </p>
          </div>
          <el-table tripe border :data="form.file" style="width: 100%">
            <el-table-column type="index" label="#" align="center" width="60">
            </el-table-column>
            <el-table-column prop="name" :label="`文件名`" align="center">
            </el-table-column>
            <!-- <el-table-column prop="type" :label="`类型`" align="center">
              <template slot-scope="scope">
                {{
                  fileTypes.filter((i) => i.value === scope.row.type)[0].name
                }}
              </template>
            </el-table-column> -->
            <el-table-column prop="address" align="center" :label="`操作`">
              <template slot-scope="scope">
                <el-button
                  class="p0 fontsize20"
                  type="text"
                  @click.prevent="view(scope.row.url)"
                  ><i class="el-icon-download"></i
                ></el-button>
                <el-button
                  class="p0 fontsize20"
                  type="text"
                  @click.prevent="deleteFile(scope.$index)"
                  ><i class="el-icon-delete"></i
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="mt10">
        <el-button size="mini" type="primary" @click="save()">保存</el-button>
        <el-button size="mini" @click="back()">取消</el-button>
      </div>
    </div>
    <PictureSelect ref="pictureSelect" @complete="getPicture" />
    <UploadFile ref="uploadFile" @complete="getFile" />
  </div>
</template>

<script>
import PictureSelect from "@/components/common/PictureSelect/index.vue";
import UploadFile from "@/components/common/UploadFile.vue";
import { vendorOptions, machineEdit, machineList } from "@/api.js";
export default {
  name: "MachineEdit",
  components: {
    PictureSelect,
    UploadFile,
  },
  data() {
    return {
      checkDayoptions: [
        {
          label: "无",
          value: "0",
        },
        {
          label: "星期一",
          value: "1",
        },
        {
          label: "星期二",
          value: "2",
        },
        {
          label: "星期三",
          value: "3",
        },
        {
          label: "星期四",
          value: "4",
        },

        {
          label: "星期五",
          value: "5",
        },
        {
          label: "星期六",
          value: "6",
        },
        {
          label: "星期日",
          value: "7",
        },
      ], //检验时间选项
      activeTab: "basic",
      form: {
        // is_default: 1,
        status: 0,
        // reset_pot_number: 0,
        handle_type: undefined,
        // is_run_print: 1,
        is_end_pot: 0
      },
      programForm: {
        name: "",
        code: "",
        is_bd: 0,
        is_test: 0,
        can_empty: 0,
        is_default: 0,
        leak_check_day: ["0"],
        is_default_biotest: 0,
        is_force_empty: 0,
        biotest_times: 0,
      },
      status: [
        {
          //启用
          name: `启用`,
          value: 0,
        },
        {
          // 停用
          name: `禁用`,
          value: 1,
        },
      ],
      types: [],
      areas: [],
      cleanMethods: [],
      createVendors: [],
      saleVendors: [],
      fileTypes: [],
      rules: {
        name: [{ required: true, message: `名称不能为空`, trigger: "blur" }],
        type: [
          {
            required: true,
            // 请选择设备类型
            message: `类型不能为空`,
            trigger: ["blur", "change"],
          },
        ],
        status: [
        // 请选择设备状态
          { required: true, message: `请选择设备状态`, trigger: ["blur"] },
        ],
        // is_default: [
        //   {
        //     required: true,
        //     // 请选择是否为默认设备
        //     message: "请选择是否为默认设备",
        //     trigger: ["change"],
        //   },
        // ],
        handle_type: [
          {
            required: false,
            // 请选择灭菌方式
            message: `请选择灭菌方式`,
            trigger: ["change"],
          },
        ],
      },
      programRules: {
        // 请输入程序名
        name: [{ required: true, message: `名称不能为空`, trigger: "blur" }],
        biotest_times: [
          {
            required: false,
            // 请选择生物监测频率
            message: `请选择生物监测频率`,
            trigger: ["change"],
          }
        ]
      },
      qcSterilizationTypeList: [],
      qcTypeList: [],
      bilogcheckTimeOptions: [],
    };
  },
  async created() {
    await Promise.all([
      this.getDicts(),
      // this.getCreateVendors(),
      // this.getSaleVendors(),
    ]);
    const { id } = this.$route.params;
    this.pageId = Number(id);
    if (this.pageId) {
      this.getDetail();
    }
  },
  methods: {
    getDicts() {
      // 获取需要用到的字典值
      return this.$utils.getDict([313, 315, 4, 320, 479, 480, 341]).then((res) => {
        this.types = res[313];
        this.areas = res[315];
        this.cleanMethods = res[4];
        this.fileTypes = res[320];
        this.qcSterilizationTypeList = res[479];
        this.qcTypeList = res[480];
        this.bilogcheckTimeOptions = res[341];
      });
    },
    async getDetail() {
      // 获取设备详情
      const { pageId } = this;
      const url = machineEdit.replace("{id}", pageId);
      const res = await this.$request("get", url, {});
      if (res) {
        this.form = res;
        this.form.file_id = this.form.file.map((i) => i.id);
        this.form.image_file_id = this.form.image.map((i) => i.id);
        if (this.form.type === 2) {
          this.$refs["form"].rules.handle_type[0].required = true;
        } else {
          this.$refs["form"].rules.handle_type[0].required = false;
        }
      }
    },
    getPicture(pictures) {
      // 获取图片列表
      const list = pictures.map((i) => {
        return { id: i.fileId, url: i.fileUrl };
      });
      const images = (this.form.image || []).concat(list);
      this.$set(this.form, "image", images);
    },
    getFile(file) {
      // 接受文件
      const files = this.form.file || [];
      files.push({
        id: file.fileId,
        url: file.fileUrl,
        name: file.name,
        type: file.type,
      });
      this.$set(this.form, "file", files);
    },
    getVendors(type = "") {
      return this.$request("get", vendorOptions, { type });
    },
    changeFormRequired() {
      // 修改灭菌方式的必填设置
      if (this.form.type === 2) {
        this.$refs["form"].rules.handle_type[0].required = true;
      } else {
        this.$refs["form"].rules.handle_type[0].required = false;
        this.form.handle_type = undefined;
        this.programForm.is_bd = 0;
        this.programForm.is_test = 0;
        this.programForm.can_empty = 0;
        if (this.form.program && this.form.program.length) {
          this.form.program.forEach((i) => {
            i.is_bd = 0;
            i.is_test = 0;
            i.can_empty = 0;
          });
        }
      }
    },
    changeBiotest() {
      if (this.programForm.is_default_biotest === 1) {
        this.$refs["programForm"].rules.biotest_times[0].required = true
      } else {
        this.$refs["programForm"].rules.biotest_times[0].required = false
      }
    },
    handleTypeChange(value) {
      // 处理方式变化时影响程序中的属性
      if (value !== 1) {
        this.programForm.is_bd = 0;
        this.programForm.is_test = 0;
        this.programForm.can_empty = 0;
        this.form.program.forEach((i) => {
          i.is_bd = 0;
          i.is_test = 0;
          i.can_empty = 0;
        });
      }
    },
    async getCreateVendors() {
      return this.getVendors(5).then((res) => {
        if (res) {
          this.createVendors = res;
        }
      });
    },
    async getSaleVendors() {
      return this.getVendors(6).then((res) => {
        if (res) {
          this.saleVendors = res;
        }
      });
    },
    back() {
      this.$router.back();
    },
    uploadPicture() {
      // 上传照片
      this.$refs.pictureSelect.show();
    },
    delImg(index) {
      this.form.image.splice(index, 1);
    },
    addProgram() {
      // 添加程序
      this.$refs.programForm.validate((valid) => {
        if (!valid) {
          // 请填写程序名称
          this.$message.error(`请填写程序名称`);
        } else {
          const { name, time, is_default, can_empty, remark, is_bd, is_test , leak_check_day, is_default_biotest, biotest_times, is_force_empty} =
            this.programForm;
          const isDefaultLength = (this.form.program || []).filter(
            (i) => i.is_default === 1
          ).length;
          if (is_default === 1 && isDefaultLength > 0) {
            // 只能设置一个默认程序
            this.$message.error(`只能设置一个默认程序`);
            return;
          }

          const item = {
            name,
            time,
            is_default,
            can_empty,
            remark,
            is_bd,
            is_test,
            leak_check_day,
            is_default_biotest,
            is_force_empty,
            biotest_times: is_default_biotest === 0 ? 0 : biotest_times,
          };

          const program = this.form.program || [];
          program.push(item);

          this.$set(this.form, "program", program);
        }
      });
    },
    deleteFile(index) {
      // 删除文件
      this.form.file.splice(index, 1);
    },
    save() {
      // 保存信息
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          // this.$message.error("请填写必填项");
          this.$message.error(`请填写必填项`);
          this.activeTab = "basic";
        } else {
          const { pageId } = this;
          const url = pageId
            ? machineEdit.replace("{id}", pageId)
            : machineList;
          if (this.form.file) {
            this.form.file_id = this.form.file.map((i) => i.id);
          }
          if (this.form.image) {
            this.form.image_file_id = this.form.image.map((i) => i.id);
          }
          const res = await this.$request("post", url, this.form);
          if (res) {
            // this.$message.success(`${pageId ? "编辑" : "新建"}成功`);
            this.$message.success(`${pageId ? `新建` : `编辑`}成功`);
            // this.back()
            if (pageId) {
              this.getDetail();
            } else {
              this.$router.replace(`/basic/machine/edit/${res}`);
              this.pageId = Number(res);
            }
          }
        }
      });
    },
    handleDefaultChange(item) {
      const isDefaultLength = this.form.program.filter(
        (i) => i.is_default === 1
      ).length;
      if (isDefaultLength > 1) {
        // this.$message.error("只能设置一个默认程序");
        this.$message.error(`只能设置一个默认程序`);
        this.$set(item, "is_default", 0);
      }
    },
    handleBDChange(item) {
      if (item.is_bd === 1) {
        item.is_test = 0;
        if (item.is_force_empty != 1) {
          item.can_empty = 1;
        }
      } else if (item.is_bd === 0 && item.is_test === 0) {
        if (item.is_force_empty != 1) {
          item.can_empty = 0;
        }
      }
    },
    handleForceEmptyChange(item) {
      if (item.is_force_empty === 1) {
        item.can_empty = 1
      }
    },
    handleTestChange(item) {
      if (item.is_test === 1) {
        item.can_empty = 1;
      } else if (item.is_bd === 0 && item.is_test === 0) {
        item.can_empty = 0;
      }
    },
    uploadFile() {
      this.$refs.uploadFile.show();
    },
    deleteProgram(index) {
      this.form.program.splice(index, 1);
    },
    view(url) {
      window.open(url, "_blank");
    },
    handleBiotestChange(item) {
      if (item.is_default_biotest === 0) {
        item.biotest_times = 0
      } else {
        item.biotest_times = 1
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
.machine-edit {
  position: relative;
  .upload_img {
    display: flex;
    .img {
      width: 60px;
      height: 60px;
      position: relative;
      margin: 10px;
      img {
        width: 100%;
        height: 100%;
      }
      .del {
        position: absolute;
        right: 3px;
        top: -6px;
        color: gray;
        width: 6px;
        height: 6px;
        cursor: pointer;
      }
    }
  }
  .flex-card {
    margin: 0 0 0 40px;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  /deep/ .long-label {
    color: red;
  }
  .equipment_card {
    margin-left: 20px;
    margin-top: 10px;
    .el-card {
      width: 250px;
      /deep/ .el-card__header {
        padding: 10px 10px;
        background: $main_color_deep;
        color: white !important;
      }
      /deep/ .el-button--text {
        color: white !important;
      }
    }
  }
}
</style>